import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  BUTTON_DISCARD,
  BUTTON_GO_BACK,
  BUTTON_YES_I_SURE,
  DISCARD_OPTIMIZATION_ALERT_TITLE,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import Button from "../Buttons/Button";

const buttonSx = {
  height: 32,
  fontSize: "0.75rem",
  minWidth: 100,
};

const TaskAlertDiscardActions = ({
  isConfirming = false,
  descriptionKey,
  onStartDiscard = () => {},
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  const { t } = useTranslationApp();

  if (isConfirming) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          variant="body2"
          sx={{ fontSize: "0.875rem", fontWeight: 500, color: "text.primary" }}
        >
          {t(DISCARD_OPTIMIZATION_ALERT_TITLE)}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontSize: "0.75rem", color: "text.secondary" }}
        >
          {t(descriptionKey)}
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 0.2 }}>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onCancel();
            }}
            size="small"
            color="secondary"
            sx={buttonSx}
          >
            {t(BUTTON_GO_BACK)}
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onConfirm();
            }}
            size="small"
            color="primary"
            sx={buttonSx}
          >
            {t(BUTTON_YES_I_SURE)}
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Button
      onClick={(e) => {
        e.stopPropagation();
        onStartDiscard();
      }}
      size="small"
      color="secondary"
      sx={buttonSx}
    >
      {t(BUTTON_DISCARD)}
    </Button>
  );
};

export default TaskAlertDiscardActions;
